export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-gradient-to-br from-background-50 via-background-100 to-primary-50/30"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-200/20 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-200/20 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-5">
              {['高清流畅', '不缓冲不卡顿', '全集免费'].map((tag) => (
                <span
                  key={tag}
                  className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-900 leading-tight mb-4">
              爱豆影视 — 偶像综艺高清免费在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-6">
              热门综艺真人秀，随时随地畅享流畅播放体验
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              爱豆影视为您提供热门综艺、真人秀、偶像综艺高清免费在线观看，不缓冲不卡顿，流畅播放全集。每日精选国内外最新偶像团体综艺、选秀节目、真人秀等多元化内容，覆盖热门IP与独家专题，让您不错过任何精彩瞬间。
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-fire-line text-accent-500 text-lg"></i>
                <span>每日更新<strong className="text-foreground-800">50+</strong>综艺</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-4k-line text-accent-500 text-lg"></i>
                <span><strong className="text-foreground-800">1080P</strong>高清画质</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-group-line text-accent-500 text-lg"></i>
                <span>覆盖<strong className="text-foreground-800">200+</strong>偶像团体</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-primary-300 text-primary-600 hover:bg-primary-50 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-thumb-up-line text-lg"></i>
                热门推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20modern%20streaming%20entertainment%20platform%20with%20vibrant%20stage%20performance%20atmosphere%2C%20abstract%20spotlight%20beams%20in%20warm%20coral%20and%20golden%20tones%20against%20dark%20theatrical%20background%2C%20shimmering%20light%20particles%20creating%20dynamic%20energy%2C%20minimalist%20flat%20design%20aesthetic%2C%20cinematic%20composition%2C%20no%20text%20or%20logos%2C%20clean%20geometric%20shapes%20suggesting%20digital%20media%20and%20entertainment&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="爱豆影视 - 偶像综艺高清在线观看平台主视觉"
                title="爱豆影视偶像综艺在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex gap-2">
                <div className="flex items-center gap-1.5 bg-black/40 backdrop-blur-sm rounded-full px-3 py-1.5">
                  <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
                  <span className="text-xs text-white/90 whitespace-nowrap">流畅播放中</span>
                </div>
                <div className="flex items-center gap-1.5 bg-black/40 backdrop-blur-sm rounded-full px-3 py-1.5">
                  <i className="ri-hd-line text-white/90 text-xs"></i>
                  <span className="text-xs text-white/90 whitespace-nowrap">1080P</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}